import React from "react";

export const InventoryItemsContext = React.createContext<any[] | undefined>(undefined);
